/**
 * @file NewAnnotationCardContainer.js
 * @description handles selection of annotationType
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since May 12, 2022 12:13
 */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useDispatch } from 'react-redux';

import NewAnnotationCard from './NewAnnotationCard';
import { objectDeepCopy, objectExists } from 'src/@common/utilities';
import genericChangeHandler from 'src/@common/genericChangeHandler';

import {
    annotationTypeSubmitRequest,
} from 'src/store/actions/documentAnnotator/documentAnnotatorDb.actions';

function NewAnnotationCardContainer(props) {
    const {
        annotationObj,
    } = props;

    const dispatch = useDispatch();

    // start: redux state --------------------------
    // end: redux state -----------------------------
    const [formFields, setFormFields] = useState({});
    const [fieldDirty, setFieldDirty] = useState({});

    useEffect(() => {
        // annotation fields into local state
        if (objectExists(annotationObj.annotation)) {
            const localObj = objectDeepCopy(annotationObj.annotation);
            setFormFields(localObj);
        }

    }, [annotationObj]);

    // handles changes to main fields
    const fieldUpdater = (fieldName, value) => {

        if (fieldName) {

            switch (fieldName) {
                default:
                    setFormFields({
                        ...formFields,
                        [fieldName]: value
                    })
                    break;
            }

            setFieldDirty({
                ...fieldDirty,
                [fieldName]: true,
            });
        }
    };

    const handleChange = (event, fieldName) => {
        genericChangeHandler(event, fieldName, fieldUpdater);
    };

    const handleSubmitAnnotationType = () => {
        const annotationId = formFields._id;
        const annotationType = formFields.annotationType;
        dispatch(annotationTypeSubmitRequest(annotationId, annotationType));
        setFieldDirty({});
    };

    return (
        <NewAnnotationCard
            formFields={formFields}
            handleChange={handleChange}
            handleSubmit={handleSubmitAnnotationType}
        />
    )
}

NewAnnotationCardContainer.propTypes = {
    annotationObj: PropTypes.object.isRequired,
};

export default NewAnnotationCardContainer;
